import { render, staticRenderFns } from "./PanelDistribuidorCurso.vue?vue&type=template&id=48c48306&scoped=true"
import script from "./PanelDistribuidorCurso.vue?vue&type=script&lang=js"
export * from "./PanelDistribuidorCurso.vue?vue&type=script&lang=js"
import style0 from "./PanelDistribuidorCurso.vue?vue&type=style&index=0&id=48c48306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c48306",
  null
  
)

export default component.exports